module.exports = __webpack_public_path__ + "img/8.4da726f2.jpg";